import { useEffect } from 'react'

export const useLoadingPage = () => {
  useEffect(() => {
    const isTestEnv = ['development', 'test'].includes(process.env.NODE_ENV as string)
    const loadingTcard = document.getElementById('loading-tcard')!

    setTimeout(() => {
      loadingTcard.classList.add('loading-tcard_slide-top')

      setTimeout(() => {
        loadingTcard.style.display = 'none'
      }, (isTestEnv ? 0 : 1) * 500)
    }, (isTestEnv ? 0 : 1) * 1200)
  }, [])
}
